import React, { useEffect, useState, useContext } from "react";
import { usePositionAllRegFormModal } from "@hooks/comp/usePositionAllRegFormModal";
import { get } from "@utils/axios_api";
import { FormProvider } from "react-hook-form";
import { formatUseYn } from "@utils/formatUseYn";
import { AuthContext } from "@context/AuthContext";
import { ROLES } from "@constants/roles";

const PositionExcelUpload = () => {
    const { auth } = useContext(AuthContext);
    const [selectedCompCode, setSelectedCompCode] = useState("");
    const [selectedCompName, setSelectedCompName] = useState("");
    const [companyList, setCompanyList] = useState([]);
    const [loading, setLoading] = useState(false);

    const {
        methods,
        handleFormSubmit,
        previewData,
        loading: formLoading,
        handleSampleDownload,
        saveData,
    } = usePositionAllRegFormModal({
        compCode: selectedCompCode,
        onClose: () => {

        },
    });

    const { register } = methods;

    // 회사 목록 조회 - Employee와 동일한 API 사용
    useEffect(() => {
        if (auth.role === ROLES.COMP_ADMIN) {
            setCompanyList([{ compCode: auth.compCode, compName: auth.compName }]);
            setSelectedCompCode(auth.compCode);
            setSelectedCompName(auth.compName);
            return;
        }

        const fetchCompanyList = async () => {
            try {
                setLoading(true);
                const response = await get("/admin/corp/corplist", {
                    params: {
                        pageIndex: 1,
                        recordCountPerPage: 1000,
                        pageSize: 10
                    }
                });
                if (response && response.resultList) {
                    setCompanyList(response.resultList);
                } else {
                    setCompanyList([]);
                }
            } catch (error) {
                setCompanyList([]);
            } finally {
                setLoading(false);
            }
        };
        fetchCompanyList();
    }, [auth.role, auth.compCode, auth.compName]);

    // 회사 선택 핸들러
    const handleCompanySelect = (e) => {
        const selectedValue = e.target.value;
        if (selectedValue) {
            const [compCode, compName] = selectedValue.split("|");
            setSelectedCompCode(compCode);
            setSelectedCompName(compName);
        } else {
            setSelectedCompCode("");
            setSelectedCompName("");
        }
    };

    return (
        <FormProvider {...methods}>
            <div className="contents-wrap">
                <div className="page-title-wrap">
                    <h2>
                        <span className="icon-dot-circle"></span>
                        직위 일괄 등록
                    </h2>
                </div>

                <div className="tab-cont-wrap">
                    <div className="tab-cont-01 on">
                        <form onSubmit={handleFormSubmit}>
                            <div className="search-wrap">
                                <table className="table-list" style={{width: "100%", marginBottom: "20px"}}>
                                    <tbody>
                                    <tr>
                                        <td colSpan="2" style={{textAlign: "left", padding: "10px"}}>
                                            1. 직위등록 샘플양식을 다운로드 받아 작성한 후 업로드 하십시오.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" style={{textAlign: "left", padding: "10px"}}>
                                            2. <strong>회사 정보는 엑셀에 입력하지 마세요.</strong> 선택한 회사로 자동 설정됩니다.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" style={{textAlign: "left", padding: "10px"}}>
                                            3. 정렬순서는 숫자로 입력하고, 사용여부는 Y(사용) 또는 N(사용안함)으로 입력하세요.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" style={{textAlign: "left", padding: "10px"}}>
                                            4. 업로드 될 직위 정보를 확인한 후 등록하기 버튼을 클릭하면 직위 등록이 완료됩니다.
                                        </td>
                                    </tr>

                                    {/* 회사 선택 영역 */}
                                    <tr>
                                        <th style={{ width: "20%", padding: "10px" }}>회사 선택</th>
                                        <td style={{ width: "80%", padding: "10px" }}>
                                            <select
                                                value={selectedCompCode ? `${selectedCompCode}|${selectedCompName}` : ""}
                                                onChange={handleCompanySelect}
                                                className="input-customtext"
                                                style={{ width: "300px", marginRight: "10px" }}
                                                disabled={loading}
                                            >
                                                <option value="">회사를 선택하세요</option>
                                                {companyList.map((company, index) => (
                                                    <option
                                                        key={index}
                                                        value={`${company.compCode}|${company.compName}`}
                                                    >
                                                        {company.compName}
                                                    </option>
                                                ))}
                                            </select>
                                            {loading && <span style={{ color: "#666", fontSize: "14px" }}>로딩 중...</span>}
                                        </td>
                                    </tr>

                                    {/* 선택된 회사 정보 표시 */}
                                    {selectedCompCode && (
                                        <tr>
                                            <th style={{width: "20%", padding: "10px"}}>선택된 회사</th>
                                            <td style={{width: "80%", padding: "10px"}}>
                                                <div style={{display: "flex", alignItems: "center", gap: "20px"}}>
                                                    <span style={{
                                                        fontSize: "16px",
                                                        fontWeight: "bold",
                                                        color: "#333"
                                                    }}>
                                                        {selectedCompName}
                                                    </span>
                                                    <span style={{fontSize: "14px", color: "#666"}}>
                                                        (코드: {selectedCompCode})
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    )}

                                    <tr>
                                        <th style={{width: "20%", padding: "10px"}}>엑셀 업로드</th>
                                        <td style={{width: "80%", padding: "10px"}}>
                                            <div style={{display: "flex", alignItems: "center", marginBottom: "8px"}}>
                                                <input
                                                    type="file"
                                                    id="uploadFile"
                                                    name="file"
                                                    accept=".xlsx,.xls"
                                                    className="input-customtext"
                                                    style={{marginRight: "10px"}}
                                                    {...register("file")}
                                                />
                                            </div>
                                            <div style={{marginBottom: "4px"}}>
                                                <small>먼저 샘플양식을 다운로드하세요. 복수 시트는 지원하지 않습니다.</small>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                                <div className="btn-right-box" style={{marginBottom: "20px"}}>
                                    <ul>
                                        <li>
                                            <button type="button"
                                                    className="btn-excel"
                                                    onClick={handleSampleDownload}
                                                    disabled={formLoading}
                                            >
                                                {formLoading ? "다운로드 중..." : "샘플양식 다운로드"}
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                type="submit"
                                                className="btn-write"
                                                id="preview"
                                                disabled={formLoading || !selectedCompCode}
                                            >
                                                {formLoading ? "처리 중..." : "미리보기"}
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                type="button"
                                                className="btn-write"
                                                id="save"
                                                onClick={saveData}
                                                disabled={formLoading || previewData.length === 0}>
                                                {formLoading ? "등록 중..." : "등록"}
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="section-tit-wrap">
                                <h2 className="border-left-primary" style={{marginTop: "10px", marginBottom: "20px"}}>
                                    &nbsp;업로드 데이터 미리보기
                                    <span className="total-txt">
                                        {" "} | 이 <span className="red">{previewData.length || 0}</span> 건
                                    </span>
                                </h2>
                            </div>

                            <div className="table-container-fullscreen">
                                <table className="table-list" style={{ width: "100%" }}>
                                    <colgroup>
                                        <col style={{ width: "30%" }} />
                                        <col style={{ width: "20%" }} />
                                        <col style={{ width: "15%" }} />
                                        <col style={{ width: "35%" }} />
                                    </colgroup>
                                    <thead>
                                    <tr>
                                        <th>직위명</th>
                                        <th>정렬순서</th>
                                        <th>사용여부</th>
                                        <th>비고</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {previewData.length > 0 ? (
                                        previewData.map((row, index) => (
                                            <tr key={index}>
                                                <td>{row.posName}</td>
                                                <td>{row.sort}</td>
                                                <td>{formatUseYn(row.useYn)}</td>
                                                <td>{row.notice || "-"}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" style={{ textAlign: "center" }}>
                                                업로드한 데이터가 없습니다.
                                            </td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>

                            {/* 데이터 개수 표시 */}
                            {previewData.length > 0 && (
                                <div style={{marginTop: "10px", textAlign: "right", fontSize: "14px", color: "#666"}}>
                                    이 {previewData.length}건의 직위 데이터
                                </div>
                            )}

                            {/* 주의사항 안내 */}
                            {!selectedCompCode ? (
                                <div style={{
                                    marginTop: "20px",
                                    padding: "15px",
                                    backgroundColor: "#fff3cd",
                                    border: "1px solid #ffeaa7",
                                    borderRadius: "4px",
                                    color: "#856404"
                                }}>
                                    <strong>⚠️ 주의:</strong> 회사를 선택해야 직위 등록이 가능합니다.
                                </div>
                            ) : null}
                        </form>
                    </div>
                </div>
            </div>
        </FormProvider>
    );
};

export { PositionExcelUpload };